import React from "react";
import ant, { PieConfig } from "@ant-design/charts";

interface IProps {
    percentage?: number[];
}

const HandednessGraph: React.FC<IProps> = (props: IProps) => {
    if (props.percentage.length < 2) return null;
    if (
        props.percentage[0] === 100 ||
        props.percentage[0] === 0 ||
        props.percentage[1] === 100 ||
        props.percentage[1] === 0
    )
        return null;
    type DataType = "Right" | "Left";

    interface PieChartData {
        type?: DataType;
        value?: number;
    }

    const pieChartData: PieChartData[] = [
        {
            type: "Right",
            value: Math.round(Math.round(props.percentage[0] * 10) / 10),
        },
        {
            type: "Left",
            value: Math.round(Math.round(props.percentage[1] * 10) / 10),
        },
    ];

    const config: PieConfig = {
        animation: false,
        appendPadding: 10,
        data: pieChartData,
        color: ["#5da3e3", "#a1c8eb"],
        angleField: "value",
        colorField: "type",
        radius: 0.8,
        innerRadius: 0.6,
        label: {
            type: "inner",
            offset: "-50%",
            content: "{value}%",
            autoRotate: false,
            style: {
                fill: "#666666",
                textAlign: "center",
                fontSize: 20,
            },
        },
        tooltip: {
            formatter: (datum) => {
                return { name: datum.type, value: Math.round(datum.value) + "%" };
            },
        },
        legend: false,
        interactions: [{ type: "element-selected" }, { type: "element-active" }],
        statistic: {
            title: false,
            content: {
                style: {
                    color: "#666666",
                    fontWeight: 600,
                    fontSize: "14px",
                    whiteSpace: "pre-wrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                },
                formatter: function formatter() {
                    return "Handedness" + "\n\n" + "(Left&nbsp;|&nbsp;Right)" + "\n&nbsp;";
                },
            },
        },
    };

    return <ant.Pie {...config} />;
};

export default HandednessGraph;

HandednessGraph.defaultProps = {
    percentage: [50, 50],
};
